function TextBanner() {
    $PrevSelectedDesktop = $("#AnoncementArea ul.desktopSlide li.selectedBannerDesktop")
    $PrevSelectedDesktop.removeClass("selectedBannerDesktop")

    if ($("#AnoncementArea ul.desktopSlide li").length != $PrevSelectedDesktop.index() + 1) {
        $PrevSelectedDesktop.next().addClass("selectedBannerDesktop");
    } else {
        $("#AnoncementArea ul.desktopSlide li").first().addClass("selectedBannerDesktop");
    }

    $PrevSelectedMobile = $("#AnoncementArea ul.mobileSlide li.selectedBannerMobile")
    $PrevSelectedMobile.removeClass("selectedBannerMobile")

    if ($("#AnoncementArea ul.mobileSlide li").length != $PrevSelectedMobile.index() + 1) {
        $PrevSelectedMobile.next().addClass("selectedBannerMobile");
    } else {
        $("#AnoncementArea ul.mobileSlide li").first().addClass("selectedBannerMobile");
    }
}

function settingTextBanner() {
    setInterval(TextBanner, 7000);
}


function GetLayoutTextBanners() {
    $.ajax({
        type: 'get',
        async: true,
        cache: false,
        url: getRequestRoute() + "/p/Home/GetTextBannerList",
        success: function (dt) {
            if (dt.length > 0) {
                var desktopCounter = 0;
                var mobileCounter = 0;
                for (var i = 0; i < dt.length; i++) {
                    if (dt[i].Area == 12) {
                        if (desktopCounter == 0) {
                            $("#AnoncementArea ul.desktopSlide").append("<li class='hidden-xs hidden-sm selectedBannerDesktop'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            desktopCounter++;
                        } else {
                            $("#AnoncementArea ul.desktopSlide").append("<li class='hidden-xs hidden-sm'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            desktopCounter++;
                        }
                    } else {
                        if (mobileCounter == 0) {
                            $("#AnoncementArea ul.mobileSlide").append("<li class='hidden-lg hidden-md selectedBannerMobile'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            mobileCounter++;
                        } else {
                            $("#AnoncementArea ul.mobileSlide").append("<li class='hidden-lg hidden-md'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            mobileCounter++;
                        }
                    }
                }
            }

            settingTextBanner();
        }
    });
}



//function CookieNotificationControl() {
//    if ($("#CookieNotificationArea").length > 0) {
//        //$(document).on("click", "#CookieNotificationArea .sorsfont-cancel", function () {
//        //    $(this).closest("#CookieNotificationArea").css("display","none");
//        //});

//        $('#CookieNotificationArea .sorsfont-cancel').click(function () {
//            $(this).closest("#CookieNotificationArea").css("display", "none");
//        });

//        $(document).on("click", "#CookieNotificationArea .CloseCookieNotification", function () {
//           // $(this).closest("#CookieNotificationArea").addClass("close");
          
//           window.location.href = "/k/kvkk-aydinlatma-metni";
//        });
//        var cookieName = 'Site1Cookie_Notification';
//        var cookieValue = 'Site1Cookie_val280518';
//        if (getCookie("Site1Cookie_Notification") == "") {
//            $("#CookieNotificationArea").css("display", "block");
//            setCookie(cookieName, cookieValue);
//        }
//    }
//}



$(document).ready(function () {
    settingTextBanner();
    //GetLayoutTextBanners();
    //CookieNotificationControl();

    if (!isMobileResolution()) {
        $("#HomeBannerSection .SBanner").each(function (index) {
            if ($(this).find(".mobile-section").length > 0) {
                caruselInner = $(this).find(".mobile-section").closest(".carousel-inner");

                $(this).find(".mobile-section").closest(".carousel-item").remove();
                caruselInner.find(".carousel-item").first().addClass("active");                
            }

            // BannerImgCount sayısı 2 geldiği için gelen slider kaydırma butonları da remove yapılıyor
            if ($(this).find(".carousel-inner .carousel-item").length <= 1) {
                $(this).find("> a").remove();
            }
        });
    }
    else {
        $("#HomeBannerSection .SBanner").each(function (index) {
            if ($(this).find(".desktop-section").length > 0) {
                caruselInner = $(this).find(".desktop-section").closest(".carousel-inner");

                $(this).find(".desktop-section").closest(".carousel-item").remove();
                caruselInner.find(".carousel-item").first().addClass("active");
            }

            //if ($(this).find(".carousel-inner .carousel-item").length <= 1) {
            //    $(this).find("> a").remove();
            //}
        });
    }
    $('.bottomMenu .open p').click(function () {
        $(this).parent().toggleClass("open");
    });

    $(document).on("click", "#Anasayfa1 .ScrollDown i", function () {
        var height = $("#HomeBannerSection #Anasayfa1").height();

        $("html, body").animate({ scrollTop: height }, 500, 'swing');
    });

    if (!isMobileResolution()) {
        // #AnasayfaVideoMobile mevcutsa onu kaldır
        var $mobileVideoBanner = $("#AnasayfaVideoMobile");
        if ($mobileVideoBanner.length > 0) {
            $mobileVideoBanner.find("#video-banner").remove();
        }

        var $mobileVideo5Banner = $("#Anasayfa5VideoMobile");
        if ($mobileVideo5Banner.length > 0) {
            $mobileVideo5Banner.find("#video-banner").remove();
        }
    }
    else {
        var $webVideoBanner = $("#AnasayfaVideo");
        if ($webVideoBanner.length > 0) {
            $webVideoBanner.find("#video-banner").remove();
        }

        var $webVideo5Banner = $("#Anasayfa5Video");
        if ($webVideo5Banner.length > 0) {
            $webVideo5Banner.find("#video-banner").remove();
        }
    }

    $(document).on("click", ".js-video-unmute", function () {

        $('.js-video-mute').show();
        $('.js-video-unmute').hide();

        $("#video-banner").prop('muted', true);
    });

    $(document).on("click", ".js-video-mute", function () {
        $('.js-video-mute').hide();
        $('.js-video-unmute').show();

        $("#video-banner").prop('muted', false);
    });
});

$(window).load(function () {
    $(".UseLazyLoad").Lazy();
});